import React from 'react';
import { SocialIcon } from 'react-social-icons';
import './Footer.css';

class Footer extends React.Component {
  render() {return (
    <footer>
      <div className="text">
        
        &copy; 2021 TypeSkripp Blog. <br/>
      
        <a href="/hakkinda">TypeSkripp</a> ekibi tarafından ❤️ ile geliştirildi.

        <div className="social-links">
          <SocialIcon
            url="#"
            style={{width: "35px", height: "35px"}}
          />

          <SocialIcon
            url="#"
            style={{width: "35px", height: "35px"}}
          />

          <SocialIcon
            url="#"
            style={{width: "35px", height: "35px"}}
          />
        </div>
      </div>
    </footer>
  )}
};

export default Footer;